<template>
  <div class="container">
    <div class="image-content">
      <img
        class="image"
        :src="
          imageSource ||
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/betterwe_h5/1650872427979'
        "
        alt=""
      />
    </div>
    <div class="bottom">
      <div class="btn iconfont icon-fanhui1" @click="bindClose"></div>
      <div class="btn active iconfont icon-gou" @click="bindConfirm"></div>
    </div>
    <InterpretingComponent
      v-if="showRead"
      :src="imageSource"
    ></InterpretingComponent>
  </div>
</template>
<script>
import InterpretingComponent from './components/interpreting.vue'
import lrz from 'lrz'
import axios from 'axios'
import { _getCookie } from '@/request/http.js'
export default {
  props: {
    src: {
      default: ''
    }
  },
  components: {
    InterpretingComponent
  },
  data() {
    return {
      showRead: false,
      readResultData: '', //第三方解读文字结果列表
      cdnImageUrl: '', //上传后的cdn图片链接
      lrzImage: '',
      deepLrzImage: ''
    }
  },
  computed: {
    imageSource() {
      return this.$store.state.ingredient.imageSource || ''
    }
  },
  created() {
    // this.getData();
  },
  methods: {
    getData() {
      let params = {
        barcode: '6924160714017',
        headerObj: {
          authorization: 'APPCODE 0594ba1d3ada4640bf412a041d2075d1',
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }
      this.$http
        .get('https://jisutxmcx.market.alicloudapi.com/barcode2/query', params)
        .then((res) => {})
        .catch((err) => {})
    },
    bindClose() {
      this.$router.go(-1)
    },
    bindConfirm() {
      this.showRead = true
      this.lrzResource()
    },
    //压缩用户选择的图片
    lrzResource() {
      lrz(this.imageSource, { width: 1200, quality: 1 })
        .then((rst) => {
          // 处理成功会执行
          console.log('普通压缩成功')
          this.lrzImage = rst.base64
          this.uploadImage()
        })
        .catch(function (err) {
          this.$toast('普通压缩失败')
          // 处理失败会执行
        })
        .always(function () {
          // 不管是成功失败，都会执行
        })
    },
    dataURItoBlob(base64Data) {
      var byteString
      if (base64Data.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(base64Data.split(',')[1])
      else byteString = unescape(base64Data.split(',')[1])
      var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },
    //深度压缩图片上传到oss
    deepLrzResource() {
      lrz(this.imageSource, { width: 300, quality: 0.5 })
        .then(async (rst) => {
          // 处理成功会执行
          console.log('极度压缩成功')
          this.deepLrzImage = rst.base64
          try {
            var fileImage = this.$http.base64ToPngFile(
              this.deepLrzImage,
              '配料表图片.png'
            ) // 上一步中的函数
            let res = await this.$http
              .uploadAppImage(fileImage, 8)
              .catch(() => {
                this.$toast('上传图片异常')
              })
            if (res) {
              res = res.data
              if (res.code === 200 && res.data.savePath) {
                this.cdnImageUrl = res.data.savePath
                this.postInterpretData()
              } else {
                this.$toast('上传出错')
              }
            }
            /*   this.$http
              .uploadOss(blob)
              .then((res) => {
                this.cdnImageUrl = res.fullPath
                this.postInterpretData()
              })
              .catch((err) => {
                this.$toast('上传图片失败')
                console.log(err)
              }) */
          } catch (error) {
            console.log(error)
          }
          //this.getAuth();
        })
        .catch(function (err) {
          this.$toast('压缩上传图片失败')
          this.$toast('极度压缩失败')
          // 处理失败会执行
        })
        .always(function () {
          // 不管是成功失败，都会执行
        })
    },
    //第三方接口解读文字（通过后端API调用）
    uploadImage() {
      // 创建FormData对象用于上传文件
      const formData = new FormData()
      // 将base64转换为File对象（自动识别原始MIME类型）
      const fileImage = this.$http.base64ToFile(this.lrzImage)
      console.log("fileImage", fileImage)
      formData.append('photo_img', fileImage)
      // 获取token（使用与postBaseApp相同的获取方式）
      const token = _getCookie('token')
      // 获取APP端域名
      const appUrl = this.$http.formatApp('tool/Ingredient/ocrImage')
      // 发送POST请求上传图片
      axios({
        method: 'post',
        url: appUrl,
        data: formData,
        headers: {
          token: token
        },
        timeout: 30000
      })
        .then((res) => {
          res = res.data
          console.log('OCR识别成功')
          if (res.code !== 200 || !res.data || !res.data.length) {
            console.log('OCR识别失败')
            this.$router.replace('/ingredient/error')
            return
          }
          this.readResultData = res.data
          this.deepLrzResource()
        })
        .catch((err) => {
          console.log('OCR识别失败', err)
          this.$router.replace('/ingredient/error')
        })
    },
    postInterpretData() {
      let params = {
        data: this.readResultData
      }
      this.$http
        .postBaseApp('tool/Ingredient/dealIngredientText', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data.data && res.data.data.length) {
              res.data.cdnUrl = this.cdnImageUrl
              this.$router.replace({
                path: '/ingredient/result',
                query: {
                  data: JSON.stringify(res.data)
                }
              })
            } else {
              //this.$toast("解读配料表失败");
              this.$router.replace('/ingredient/error')
            }
          } else {
            this.$toast(res.msg)
            this.$router.replace('/ingredient/error')
          }
        })
        .catch(() => {
          //this.$toast("解读配料表失败");
          this.$router.replace('/ingredient/error')
        })
    },
    alertRes(data) {
      let str = ''
      data.map((item) => {
        str += item.word
      })
      alert(str)
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .image-content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    width: 100%;
    background: #fcefed;
    .image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .bottom {
    width: 100%;
    height: 185px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .btn {
      width: 48px;
      height: 48px;
      font-size: 26px;
      border: 3px solid #979797;
      color: #979797;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .active {
      border: 3px solid #63c6ab;
      color: #63c6ab;
    }
  }
}
</style>
